import * as cordova from "./cordova/platformImpl";
import * as pushLibCordova from "./cordova/pushLib";
import * as web from "./web/platformImpl";
import * as pushLibWeb from "./web/pushLib";

const getPlatformImplementation = () => (window.cordova ? cordova : web);

const getPushLibImplementation = () =>
  window.cordova ? pushLibCordova : pushLibWeb;

const {
  platform,
  reviewDialog,
  openStoreScreen,
  getPlatformName,
  checkGovBrInstalado,
  openGovBr,
  openMarketplace,
  criarDownloadPdfImpl,
  downloadArquivosImpl,
  closeBrowserTab,
  openLoginPage,
  openLogoutUrl,
  openKbaPage,
  showPdfLocal,
  oldServicesUrl,
  getDevicePlatform,
  getVersion,
  update,
  exit,
  requestCameraPermission
} = getPlatformImplementation();

const {
  requestPermission,
  registerOnMessage,
  registerOnToken,
  getOnToken,
  subscribeToTopic,
  unsubscribeToTopic,
  FingerPrintIsAvailable,
  FingerPrintShow,
  captureImage,
  getImageBase64,
  captureImageHighDefinition,
} = getPushLibImplementation();

export {
  FingerPrintIsAvailable,
  FingerPrintShow,
  captureImage,
  checkGovBrInstalado,
  criarDownloadPdfImpl,
  downloadArquivosImpl,
  exit,
  getDevicePlatform,
  getImageBase64,
  getOnToken,
  getPlatformName,
  getVersion,
  oldServicesUrl,
  openGovBr,
  openKbaPage,
  closeBrowserTab,
  openLoginPage,
  openLogoutUrl,
  openMarketplace,
  openStoreScreen,
  platform,
  registerOnMessage,
  registerOnToken,
  requestCameraPermission,
  requestPermission,
  reviewDialog,
  showPdfLocal,
  subscribeToTopic,
  unsubscribeToTopic,
  update,
  captureImageHighDefinition
};
